<template>
	<div>
		<div class="col-sm-3 no-print">
			<div class="row">
				<div class="col-md-12 form-group">
					<label>* Estado:</label> <br />

					<p v-show="controle.loadTipo"><i class="fa fa-refresh fa-spin fa-fw"></i>Carregando...</p>

					<select v-show="!controle.loadTipo" @change="setaTipo" class="form-control input-sm" v-model="tipo">
						<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
						<option v-for="(item, index) in tipos" v-bind:value="item.id" :key="index">{{ item.nome }} - {{ item.sigla }}</option>
					</select>
				</div>
			</div>

			<div class="row form-group">
				<div class="col-md-12" v-show="controle.natureza">
					<label>* Cidade:</label> <br />

					<p v-show="controle.loadNatureza"><i class="fa fa-refresh fa-spin fa-fw"></i>Carregando...</p>

					<select v-show="!controle.loadNatureza" class="form-control input-sm" v-model="natureza">
						<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
						<option v-for="(item, index) in naturezas" v-bind:value="item.id" :key="index">{{ item.descricao }}</option>
					</select>
				</div>
			</div>

			<div v-if="idCliente == '5'">
				<div class="row form-group" v-show="controle.natureza">
					<div class="col-md-6">
						<label>Lat:</label> <br />
						<input
							type="text"
							v-mask="'00º00\'00S'"
							placeholder="GGºMM'SSD"
							v-model="lat"
							class="form-control input-sm"
							@blur="validaTamanhoTrecho('lat', 9)"
						/>
					</div>
					<div class="col-md-6">
						<label>Long:</label> <br />
						<input
							type="text"
							v-model="long"
							v-mask="'000º00\'00S'"
							placeholder="GGGºMM'SSD"
							class="form-control input-sm"
							@blur="validaTamanhoTrecho('lng', 10)"
						/>
					</div>
				</div>
			</div>

			<div v-if="idCliente != '5'">
				<div class="row form-group" v-show="controle.natureza">
					<div class="col-md-6">
						<label>Lat:</label> <br />
						<input type="text" v-model="lat" class="form-control input-sm" />
					</div>

					<div class="col-md-6">
						<label>Long:</label> <br />
						<input type="text" v-model="long" class="form-control input-sm" />
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<button @click="doAddItemNatureza" class="btn btn-primary btn-sm btn-block">
						<i class="fa fa-plus fa-fw"></i> {{ _traducao('global', 'adicionar') }} 
					</button>
				</div>
			</div>
		</div>

		<div class="col-sm-9">
			<table class="table table-bordered table-hover table-condensed margin-print-0" style="margin-top: 18px">
				<thead>
					<tr>
						<th class="text-center" style="width: 45%">Estado</th>
						<th class="text-center" style="width: 45%">Cidade</th>
						<th class="text-center no-print" style="width: 10%"></th>
					</tr>
				</thead>
				<tbody>
					<tr class="text-center" v-for="(item, index) in selecionados" :key="index">
						<td>{{ item.estado.nome }} - {{ item.estado.sigla }}</td>
						<td>
							{{ item.cidade.descricao }}
							<span class="label label-info" v-show="item.lat != ''"> LAT: {{ item.lat }} </span>

							<span style="margin-left: 4px" class="label label-info" v-show="item.long != ''"> LONG: {{ item.long }} </span>
						</td>
						<td class="no-print">
							<button type="button" @click.prevent="doRemoveItemNatureza(index)" class="btn btn-danger btn-xs btn-block">
								<i class="fa fa-trash fa-fw"></i> {{ _traducao('global', 'excluir') }} 
							</button>
						</td>
					</tr>
					<tr class="no-print" v-show="selecionados.length == 0">
						<td colspan="3" class="text-center">Nenhum item adicionado ainda.</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		unico: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function () {
		return {
			naturezas: [],
			tipos: [],
			natureza: '',
			tipo: '',
			lat: '',
			long: '',

			controle: {
				natureza: false,
				loadTipo: false,
				loadNatureza: false
			},
			idCliente: '',
			selecionados: []
		}
	},
	mounted: function () {
		this.getTipos()
		this.idCliente = $cliente.get('id')
	},

	methods: {
		carregaLista(lista) {
			this.limpaCampos()
			this.selecionados = lista
			this.$emit('local-missao-selecionado', this.selecionados)
		},

		limpaCampos() {
			this.selecionados = []
			this.natureza = ''
			this.tipo = ''
			this.controle.tipo = false
		},

		// REMOVE UM ITEM NA LISTA DE NATUREZA
		doRemoveItemNatureza(index) {
			var item = this.selecionados[index]

			//if(item.natureza.id == 12 && item.tipo.id == 99){
			//	this.controle.orgaoApoiado = false;
			//}

			this.selecionados.splice(index, 1)
			this.$emit('local-missao-selecionado', this.selecionados)
		},

		// ADD UM ITEM NA LISTA DE NATUREZA DA OPERACAO
		doAddItemNatureza() {
			var add = true

			// cidade e estado selecionado
			if (this.natureza != '' && this.tipo != '') {
				var add = true
				if (this.selecionados.length > 0) {
					if (this.unico == true) {
						bus.$emit('exibir-notificacao', {type: 'danger', text: 'Você pode adicionar apenas um item.'})
						return false
					} else {
						for (var i in this.selecionados) {
							if (this.selecionados[i].estado.id == this.natureza && this.selecionados[i].cidade.id == this.tipo) {
								add = false
								bus.$emit('exibir-notificacao', {type: 'danger', text: 'Item já adicionando.'})
								break
							}
						}
					}
				}

				// se não tiver add
				if (add == true) {
					var auxNatureza = []
					for (var i in this.naturezas) {
						if (this.naturezas[i].id == this.natureza) {
							auxNatureza = this.naturezas[i]
							break
						}
					}

					var auxTipo = []
					for (var i in this.tipos) {
						if (this.tipos[i].id == this.tipo) {
							auxTipo = this.tipos[i]
							break
						}
					}

					this.selecionados.push({cidade: auxNatureza, estado: auxTipo, lat: this.lat, long: this.long})
					this.$emit('local-missao-selecionado', this.selecionados)
					this.lat = ''
					this.long = ''
				}
			} else {
				bus.$emit('exibir-notificacao', {type: 'info', text: 'Você tem que escolher um estado e uma cidade.'})
			}
		},

		// SETA A NATUREZA E CARREGA O TIPO DA NATUREZA
		setaTipo() {
			if (this.tipo != '') {
				this.natureza = ''
				this._httpGet('/Cidade/get_cidade_by_id_estado/' + this.tipo, (retorno) => {
					if (retorno._request && retorno._status) {
						retorno.lista = retorno.lista.map((t) => {
							t.descricao = t.descricao.toUpperCase()
							return t
						})
						this.naturezas = []
						this.naturezas = retorno.lista
						//this.controle.loadCidade = false;
						this.controle.loadNatureza = false
						this.controle.natureza = true
					}
				})
			}
		},

		// PEGA OS TIPOS DE MISSAO NO WS
		getTipos() {
			this._providerEstado((lista) => {
				this.tipos = lista
			})
		},

		// VALIDAÇÕES DE MASCARAS
		validaTamanhoTrecho: function (campo, leng) {
			this.$nextTick(function () {
				switch (campo) {
					case 'lat':
						if (this.lat.length != leng) {
							if (this.lat.length != leng - 2) {
								this.lat = ''
							}
						}
						break
					case 'lng':
						if (this.long.length != leng) {
							if (this.long.length != leng - 2) {
								this.long = ''
							}
						}
						break
				}
			})
		}
	}
}
</script>